import React from 'react';
import { Link } from 'react-router-dom';
import Container from '@material-ui/core/Container';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import CardContent from '@material-ui/core/CardContent';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { Close, ArrowForward } from '@material-ui/icons';
import { useSelector } from 'react-redux';
import { useFirebase } from 'react-redux-firebase';
import useStyles, { StyledButton, EmailIcon } from './EmailVerification.styles';

function EmailVerification() {
    const classes = useStyles();
    // eslint-disable-next-line no-unused-vars
    const firebase = useFirebase();
    const { firstName, email } = useSelector((state) => state.firebase.profile);
    // firebase
    //     .auth()
    //     .applyActionCode('verifyEmail')
    //     .then((resp) => {
    //         console.log(resp);
    //     })
    //     .catch((error) => {
    //         // Code is invalid or expired. Ask the user to verify their email address
    //         // again.
    //         console.log(error);
    //     });

    return (
        <div className={classes.page}>
            <div className={classes.appBarWrapper}>
                <AppBar position="static" elevation={0}>
                    <Toolbar>
                        <Typography variant="h6" className={classes.brand}>
                            <Link to="/">
                                <img src="/assets/white-logo.svg" alt="Deal Depot" />
                            </Link>
                        </Typography>
                        <div>
                            <StyledButton disabled size="large" startIcon={<ArrowForward />}>
                                Need help
                            </StyledButton>
                            <StyledButton
                                component={Link}
                                to="/contact"
                                size="large"
                                variant="outlined">
                                GET IN TOUCH
                            </StyledButton>
                        </div>
                    </Toolbar>
                </AppBar>
            </div>
            <Container component="main" maxWidth="lg">
                <Card elevation={0} square>
                    <CardHeader
                        className={classes.cardHeader}
                        action={
                            <IconButton aria-label="close">
                                <Close />
                            </IconButton>
                        }
                        title={
                            <Typography
                                component="h5"
                                variant="h5"
                                className={classes.cardHeaderTitle}>
                                Create your profile
                            </Typography>
                        }
                    />
                    <CardContent className={classes.cardContent}>
                        <Grid container spacing={2} className={classes.cardContentGrid}>
                            <Grid item xs={12} className={classes.cardGridTitle}>
                                <EmailIcon />
                                <Typography
                                    component="h5"
                                    variant="h5"
                                    align="center"
                                    className={classes.cardHeaderTitle}>
                                    {firstName || 'User'}, an email is on it’s way
                                </Typography>
                                <Typography
                                    align="center"
                                    component="p"
                                    variant="body1"
                                    className={classes.cardHeaderSubTitle}>
                                    {`We've sent you an email containing a verification link to ${
                                        email || 'email'
                                    }. You'll need to verify your new account before you can begin using DealDepot.`}
                                </Typography>
                                <Button
                                    color="secondary"
                                    size="large"
                                    target="_blank"
                                    href={`mailto:${email}`}
                                    variant="contained"
                                    endIcon={<ArrowForward />}>
                                    GO TO INBOX
                                </Button>
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
            </Container>
        </div>
    );
}

export default EmailVerification;
